import styled from 'styled-components';
import { getTypographyIntent } from '../Typography/Typography.styles';
import { borderRadius } from '../_styles/borderRadius';
import { colors } from '../_styles/colors';
import { getShadow } from '../_styles/shadows';
import { spacing } from '../_styles/spacing';
export var StyledTooltip = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledTooltip",
  componentId: "core-12_21_0__sc-1fawsi4-0"
})(["", " color:", ";max-width:200px;padding:", "px ", "px;position:relative;word-wrap:break-word;overflow-wrap:break-word;white-space:normal;"], getTypographyIntent('small'), colors.white, spacing.sm, spacing.md);
export var StyledContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledContainer",
  componentId: "core-12_21_0__sc-1fawsi4-1"
})(["display:inline-flex;background-color:", ";border-radius:", "px;", " & + [data-overlay-arrow]{background:", ";}"], colors.gray15, borderRadius.md, getShadow(3, 'bottom'), colors.gray15);
//# sourceMappingURL=Tooltip.styles.js.map